import { defineComponent } from "vue";
import { mapState } from "pinia";

import { useEditReferralHH } from "../../../store/useEditReferralHH";
import { HomeHealthEthnicityEnum, HomeHealthRacesEnum } from "../../../../../enums/enums";

import FormSection from "../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";

export default defineComponent({
    components: {
        FormSection
    },

    computed: {
        ...mapState(useEditReferralHH, ["referral", "referralOptions", "currentApplication"])
    },

    methods: {
        handleEthnicity(value: string) {
            if (this.referral.Demographics.EthnicitiesOnlyCollection.includes(value)) {
                this.referral.Demographics.EthnicitiesOnlyCollection =
                    this.referral.Demographics.EthnicitiesOnlyCollection.filter((val: any) => val !== value);
                let temp = this.referral.Demographics.EthnicitiesOnly.split(";").filter((val: string) => val !== value);
                let temp2 = temp.join(";");
                this.referral.Demographics.EthnicitiesOnly = temp2;
            } else {
                this.referral.Demographics.EthnicitiesOnlyCollection.push(value);
                if (this.referral.Demographics.EthnicitiesOnly === null) {
                    this.referral.Demographics.EthnicitiesOnly = "";
                    this.referral.Demographics.EthnicitiesOnly =
                        this.referral.Demographics.EthnicitiesOnly.concat(value);
                } else {
                    this.referral.Demographics.EthnicitiesOnly.concat(`;${value}`);
                }
            }
        },
        isEthnicityDisabled(value: string) {
            if (value === "0") {
                return (
                    this.referral.Demographics.EthnicitiesOnlyCollection.includes(
                        HomeHealthEthnicityEnum.MexicanAmericanChicano
                    ) ||
                    this.referral.Demographics.EthnicitiesOnlyCollection.includes(HomeHealthEthnicityEnum.Puerto) ||
                    this.referral.Demographics.EthnicitiesOnlyCollection.includes(HomeHealthEthnicityEnum.Cuban) ||
                    this.referral.Demographics.EthnicitiesOnlyCollection.includes(
                        HomeHealthEthnicityEnum.AnotherHispanicLatinoOrSpanishOrigin
                    ) ||
                    this.referral.Demographics.EthnicitiesOnlyCollection.includes(
                        HomeHealthEthnicityEnum.PatientDeclinesToRespond
                    )
                );
            } else if (value === "1") {
                return (
                    this.referral.Demographics.EthnicitiesOnlyCollection.includes(
                        HomeHealthEthnicityEnum.NoNotOfHispanicOrigin
                    ) ||
                    this.referral.Demographics.EthnicitiesOnlyCollection.includes(
                        HomeHealthEthnicityEnum.PatientDeclinesToRespond
                    )
                );
            } else if (value === "2") {
                return (
                    this.referral.Demographics.EthnicitiesOnlyCollection.includes(
                        HomeHealthEthnicityEnum.NoNotOfHispanicOrigin
                    ) ||
                    this.referral.Demographics.EthnicitiesOnlyCollection.includes(
                        HomeHealthEthnicityEnum.PatientDeclinesToRespond
                    )
                );
            } else if (value === "3") {
                return (
                    this.referral.Demographics.EthnicitiesOnlyCollection.includes(
                        HomeHealthEthnicityEnum.NoNotOfHispanicOrigin
                    ) ||
                    this.referral.Demographics.EthnicitiesOnlyCollection.includes(
                        HomeHealthEthnicityEnum.PatientDeclinesToRespond
                    )
                );
            } else if (value === "4") {
                return (
                    this.referral.Demographics.EthnicitiesOnlyCollection.includes(
                        HomeHealthEthnicityEnum.NoNotOfHispanicOrigin
                    ) ||
                    this.referral.Demographics.EthnicitiesOnlyCollection.includes(
                        HomeHealthEthnicityEnum.PatientDeclinesToRespond
                    )
                );
            } else if (value === "5") {
                return this.referral.Demographics.EthnicitiesOnlyCollection.includes(
                    HomeHealthEthnicityEnum.PatientDeclinesToRespond
                );
            } else if (value === "6") {
                return (
                    this.referral.Demographics.EthnicitiesOnlyCollection.includes(
                        HomeHealthEthnicityEnum.NoNotOfHispanicOrigin
                    ) ||
                    this.referral.Demographics.EthnicitiesOnlyCollection.includes(
                        HomeHealthEthnicityEnum.MexicanAmericanChicano
                    ) ||
                    this.referral.Demographics.EthnicitiesOnlyCollection.includes(HomeHealthEthnicityEnum.Puerto) ||
                    this.referral.Demographics.EthnicitiesOnlyCollection.includes(HomeHealthEthnicityEnum.Cuban) ||
                    this.referral.Demographics.EthnicitiesOnlyCollection.includes(
                        HomeHealthEthnicityEnum.AnotherHispanicLatinoOrSpanishOrigin
                    ) ||
                    this.referral.Demographics.EthnicitiesOnlyCollection.includes(
                        HomeHealthEthnicityEnum.PatientUnableToRespond
                    )
                );
            } else {
                return true;
            }
        },
        handleRace(value: string) {
            if (this.referral.Demographics.RacesCollection.includes(value)) {
                this.referral.Demographics.RacesCollection = this.referral.Demographics.RacesCollection.filter(
                    (val: string) => val !== value
                );
                let temp = this.referral.Demographics.Races.split(";").filter((val: string) => val !== value);
                let temp2 = temp.join(";");
                this.referral.Demographics.Races = temp2;
            } else {
                this.referral.Demographics.RacesCollection.push(value);
                if (this.referral.Demographics.Races === null) {
                    this.referral.Demographics.Races = "";
                    this.referral.Demographics.Races = this.referral.Demographics.Races.concat(value);
                } else {
                    this.referral.Demographics.Races.concat(`;${value}`);
                }
            }
        },
        isRaceDisabled(value: string) {
            if (value === HomeHealthRacesEnum.PatientUnableToRespond) {
                return this.referral.Demographics.RacesCollection.includes(
                    HomeHealthRacesEnum.PatientDeclinesToRespond
                );
            } else if (value === HomeHealthRacesEnum.PatientDeclinesToRespond) {
                return (
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.White) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.BlackOrAfricanAmerican) ||
                    this.referral.Demographics.RacesCollection.includes(
                        HomeHealthRacesEnum.AmericanIndianorAlaskaNative
                    ) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.AsianIndian) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.Chinese) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.Filipino) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.Japanese) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.Korean) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.Vietnamese) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.OtherAsian) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.NativeHawaiian) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.GuamanianOrChamorro) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.Samoan) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.OtherPacificIslander) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.PatientUnableToRespond) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.NoneOfTheAbove)
                );
            } else if (value === HomeHealthRacesEnum.NoneOfTheAbove) {
                return (
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.White) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.BlackOrAfricanAmerican) ||
                    this.referral.Demographics.RacesCollection.includes(
                        HomeHealthRacesEnum.AmericanIndianorAlaskaNative
                    ) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.AsianIndian) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.Chinese) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.Filipino) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.Japanese) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.Korean) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.Vietnamese) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.OtherAsian) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.NativeHawaiian) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.GuamanianOrChamorro) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.Samoan) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.OtherPacificIslander) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.PatientDeclinesToRespond)
                );
            } else {
                return (
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.PatientDeclinesToRespond) ||
                    this.referral.Demographics.RacesCollection.includes(HomeHealthRacesEnum.NoneOfTheAbove)
                );
            }
        }
    }
});
